import React from "react";

export function hasPayoutPerm(
  requiredPermissions: any[],
  userPermissions: any[]
): boolean {
  const userPerm = userPermissions?.map(p => p.code);
  const hasPerm = userPerm.filter(e => requiredPermissions.includes(e));
  return hasPerm?.length ? true : false;
}

export interface PayoutPermissions {
  children: React.ReactNode | React.ReactNodeArray;
  requiredPermissions: any[];
  userPermissions: any[];
}

const PayoutPermissions: React.FC<PayoutPermissions> = ({
  children,
  requiredPermissions,
  userPermissions
}) =>
  hasPayoutPerm(requiredPermissions, userPermissions) ? <>{children}</> : null;

PayoutPermissions.displayName = "PayoutPermissions";
export default PayoutPermissions;
